import { Component, OnInit }
    from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { ElearningCourse, ElearningModule, ElearningResult }
    from "../../../models";
import { CurrentUserService } from "../../../services/shared";
import { UserHomeService } from "../userHome.service";
import { ReportService } from "./reports.service";
import { NgProgressService } from "ng2-progressbar";

@Component({
    selector: "reports-component",
    template: require("./reports.component.html"),
    styles: [require("./reports.component.less").toString()],
    providers: [ReportService]
})

export class ReportsComponent implements OnInit {

    isProcessing: boolean;
    errorMessage: string;
    activeTabId: number = 0;
    elearningCourses = new Array<ElearningCourse>();
    elearningModules = new Array<ElearningModule>();
    elearningResults = new Array<ElearningResult>();

    constructor(private pService: NgProgressService,
        private currentUserService: CurrentUserService,
        private cecRouter: Router,
        private cecActivatedRoute: ActivatedRoute,
        private userHomeService: UserHomeService) {
        this.isProcessing = false;
    }

    public setCurrentTab(tabIndex: number): void {
        this.activeTabId = tabIndex;
    };

    public onRefreshCourses(courses) {
        this.elearningCourses = courses;
    }

    public onRefreshModules(modules) {
        this.elearningModules = modules;
    }

    public onRefreshResults(results) {
        this.elearningResults = results;
    }
    ngOnInit() {

    }
}


// WEBPACK FOOTER //
// ./src/app/modules/userHome/reports/reports.component.ts